import { Formik } from 'formik';
import { isEmpty } from 'ramda';
import * as moment from 'moment';
import SeriesPost from './SeriesPost';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { useEffect, useState } from 'react';
import { baseMediaUrl } from './series.constants';
import * as actions from '../../../redux/actions';
import PhotoSearch from '../../photos/PhotoSearch';
import { TextField } from '../../common/FormFields';
import * as selectors from '../../../redux/selectors';
import PageContainer from '../../common/PageContainer';
import { DateInput } from 'semantic-ui-calendar-react';
import SearchPostsDetail from '../../email/SearchPostsDetail';
import { PLACEHOLDER_PHOTO_URL, rebelmouseGowIdSiteMap } from '../../../constants';
import {
  Breadcrumb,
  Button,
  Form,
  Item,
  Header,
  Icon,
  Menu,
  Segment,
  Image,
  Grid,
  Checkbox,
  Divider,
} from 'semantic-ui-react';

const EditSeriesPage = ({
  match,
  getUsers,
  getSeries,
  getSites,
  seriesMap,
  history,
  updateSeries,
  getSeriesPosts,
  addPostToSeries,
  removePostFromSeries,
  tagPost,
  posts,
  user,
  types,
}) => {
  const { seriesId, siteId } = match.params;

  const [current, setCurrent] = useState(seriesMap[seriesId]);

  useEffect(() => {
    getSeriesPosts(siteId, seriesId);
    getSeries(siteId);
  }, [getSeries, getSeriesPosts, seriesId, siteId]);

  useEffect(() => {
    setCurrent(seriesMap[seriesId]);
  }, [seriesMap, seriesId]);

  const handleSubmit = data => updateSeries(siteId, data);
  const handleAddPost = ({ id }) => (id ? addPostToSeries(siteId, seriesId, id) : '');
  const handleRemovePost = ({ id }) => (id ? removePostFromSeries(siteId, seriesId, id) : '');

  const getImageUrl = url => {
    if (isEmpty(url) || !url) return PLACEHOLDER_PHOTO_URL;

    if (url?.includes('http')) return url;
    const BASE = url?.includes('image/upload') ? 'https://res.cloudinary.com/culturemap-com/' : baseMediaUrl;

    return BASE + url;
  };

  const tagAllPosts = (posts, addTags) => {
    (posts || []).forEach(({ id, tags }) => {
      const temp = tags.filter(t => t !== 'hidedate');
      if (addTags) {
        tagPost(siteId, id, [...temp, 'hidedate']);
      } else {
        tagPost(siteId, id, [...temp]);
      }
    });
  };

  const getPage = () => (
    <PageContainer>
      <Formik initialValues={current} validateOnMount={true} enableReinitialize onSubmit={handleSubmit}>
        {formik => (
          <>
            <Breadcrumb>
              <Breadcrumb.Section>Series</Breadcrumb.Section>
              <Breadcrumb.Divider icon="right angle" />
              <Breadcrumb.Section>
                <Link to="/series">Dashboard</Link>
              </Breadcrumb.Section>
              <Breadcrumb.Divider icon="right angle" />
              <Breadcrumb.Section>Edit</Breadcrumb.Section>
            </Breadcrumb>

            <Menu borderless>
              <Menu.Item header>
                <Icon name="list" />
                Edit Series
              </Menu.Item>
            </Menu>

            <Segment>
              <Form widths="equal">
                <Form.Group>
                  <TextField
                    name="name"
                    label="Internal Name"
                    formik={formik}
                    value={formik.values.data.name}
                    onChange={(e, { value }) => formik.setFieldValue('data.name', value)}
                    error={formik.errors.name}
                    errorMessage={formik.errors.name}
                  />
                </Form.Group>
                <Form.Group>
                  <TextField
                    name="title"
                    label="Series Title *Series Title Populates on Front End of Site"
                    formik={formik}
                    value={formik.values.data.headline}
                    onChange={(e, { value }) => formik.setFieldValue('data.headline', value)}
                    error={formik.errors.headline}
                    errorMessage={formik.errors.headline}
                  />
                </Form.Group>
                {user.isAdmin && (
                  <Form.Group>
                    <TextField
                      name="url"
                      label="Slug"
                      formik={formik}
                      value={formik.values.url}
                      onChange={formik.handleChange}
                      error={formik.errors.url}
                      errorMessage={formik.errors.url}
                    />
                  </Form.Group>
                )}
                <Form.Group>
                  <Form.Dropdown
                    name="type"
                    label="Type"
                    clearable
                    value={formik.values.data.type}
                    error={formik.errors.type}
                    onChange={(e, { value }) => formik.setFieldValue('data.type', value)}
                    fluid
                    selection
                    options={types?.filter(t => t.value !== 'All') || []}
                  />
                </Form.Group>
                <Form.Group>
                  <TextField
                    name="data.note"
                    label="Note"
                    formik={formik}
                    value={formik.values.data.note}
                    onChange={formik.handleChange}
                    error={formik.errors.note}
                    errorMessage={formik.errors.note}
                  />
                </Form.Group>

                {formik.values.data.type !== 'single' && (
                  <>
                    <Form.Group>
                      <Form.Field>
                        <Checkbox
                          name="data.shuffle"
                          label="Shuffle Posts in Series Module"
                          checked={formik.values.data.shuffle}
                          onChange={(e, { checked }) => formik.setFieldValue('data.shuffle', checked)}
                        />
                      </Form.Field>
                    </Form.Group>
                    <Form.Group>
                      <Form.Field>
                        <Checkbox
                          name="data.homePage"
                          label="Home Page"
                          checked={formik.values.data.homePage}
                          onChange={(e, { checked }) => formik.setFieldValue('data.homePage', checked)}
                        />
                      </Form.Field>
                    </Form.Group>
                    <Form.Group>
                      <Form.Field>
                        <Checkbox
                          name="data.hideDates"
                          label="Hide Dates"
                          checked={formik.values.data.hideDates}
                          onChange={(e, { checked }) => {
                            formik.setFieldValue('data.hideDates', checked);
                            tagAllPosts(posts, checked);
                          }}
                        />
                      </Form.Field>
                    </Form.Group>
                  </>
                )}

                <Divider />

                <Form.Field>
                  <label>Start Date</label>
                  <DateInput
                    name="data.startDate"
                    value={
                      formik?.values?.data.startDate
                        ? moment(formik.values.data.startDate, 'LL').format('YYYY-MM-DD')
                        : ''
                    }
                    iconPosition="left"
                    popupPosition="bottom left"
                    dateFormat="YYYY-MM-DD"
                    closable={true}
                    onChange={(e, { value }) => formik.setFieldValue('data.startDate', moment(value, 'YYYY-MM-DD'))}
                  />
                </Form.Field>
                <Form.Field>
                  <label>End Date</label>
                  <DateInput
                    name="data.endDate"
                    value={
                      formik?.values?.data.endDate ? moment(formik.values.data.endDate, 'LL').format('YYYY-MM-DD') : ''
                    }
                    iconPosition="left"
                    popupPosition="bottom left"
                    dateFormat="YYYY-MM-DD"
                    closable={true}
                    onChange={(e, { value }) => formik.setFieldValue('data.endDate', moment(value, 'YYYY-MM-DD'))}
                  />
                </Form.Field>

                <Grid>
                  <Grid.Row>
                    <Grid.Column width="4">
                      <Header content="Banner Image" />
                      <p>*Defaults to most recent post for hero article</p>
                      <Image src={getImageUrl(formik.values.data.banner)} />
                      <br />
                      <PhotoSearch handleSelect={({ src }) => formik.setFieldValue('data.banner', getImageUrl(src))} />
                      <Button
                        icon="trash"
                        content="Remove"
                        negative
                        type="button"
                        onClick={() => formik.setFieldValue('data.banner', null)}
                      />
                      <br />
                      <br />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>

                {formik.values.data.type !== 'single' && (
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width="4">
                        <Header content="Logo" />
                        <Image src={getImageUrl(formik.values.data.logo)} />
                        <br />
                        <PhotoSearch handleSelect={({ src }) => formik.setFieldValue('data.logo', getImageUrl(src))} />
                        <Button
                          icon="trash"
                          content="Remove"
                          type="button"
                          negative
                          onClick={() => formik.setFieldValue('data.logo', null)}
                        />
                        <br />
                        <br />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                )}

                {user.isAdmin && (
                  <>
                    <Divider />

                    <Grid>
                      <Grid.Row>
                        <Grid.Column width="4">
                          <Header content="Daily Digest Series" />

                          <Form.Group>
                            <Form.Field>
                              <Checkbox
                                name="data.digestSeries"
                                label="Show in Daily Digest"
                                checked={formik.values.data.digestSeries}
                                onChange={(e, { checked }) => formik.setFieldValue('data.digestSeries', checked)}
                              />
                            </Form.Field>
                          </Form.Group>

                          <Header content="Daily Digest Header" sub />

                          <Image src={getImageUrl(formik.values.data.digestHeaderImage)} />
                          <br />
                          <PhotoSearch
                            handleSelect={({ src }) => {
                              formik.setFieldValue('data.digestHeaderImage', getImageUrl(src));
                            }}
                          />

                          <Header content="Daily Digest Logo" sub />
                          <Image src={getImageUrl(formik.values.data.digestLogoImage)} />
                          <br />
                          <PhotoSearch
                            handleSelect={({ src }) => formik.setFieldValue('data.digestLogoImage', getImageUrl(src))}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </>
                )}

                {formik.values.data.type === 'sponsored' && (
                  <>
                    <Form.Group>
                      <TextField
                        name="data.sponsorName"
                        label="Sponsor Name"
                        formik={formik}
                        value={formik.values.data.sponsorName}
                        onChange={formik.handleChange}
                        error={formik.errors.sponsorName}
                        errorMessage={formik.errors.sponsorName}
                      />
                    </Form.Group>
                    <Form.Group>
                      <TextField
                        name="data.sponsorLink"
                        label="Sponsor URL"
                        formik={formik}
                        value={formik.values.data.sponsorName}
                        onChange={formik.handleChange}
                        error={formik.errors.sponsorName}
                        errorMessage={formik.errors.sponsorName}
                      />
                    </Form.Group>
                  </>
                )}

                <Divider />

                <Header content="Posts for Series" sub />
                <Item.Group divided>
                  {(posts || []).map((post, idx) => (
                    <SeriesPost
                      key={idx}
                      post={post}
                      removeItem={handleRemovePost}
                      setBannerImage={url => formik.setFieldValue('data.banner', url)}
                    />
                  ))}

                  {!((posts || []).length > 0 && formik.values.data.type === 'single') && (
                    <Item>
                      <SearchPostsDetail
                        handleSelection={post => {
                          handleAddPost(post);
                          const imageUrl = post.image_url ? post.image_url : post.teaser_image || post.image;
                          formik.setFieldValue('data.headline', post.headline);
                          formik.setFieldValue('data.post_url', post.post_url);
                          formik.setFieldValue('data.banner', imageUrl);
                        }}
                        site={siteId}
                        contentType={'page,image,video,article'}
                        siteId={siteId}
                        trigger={<Button icon="plus" type="button" basic labelPosition="left" content="Add item" />}
                      />
                    </Item>
                  )}
                </Item.Group>
                <Button
                  positive
                  type="button"
                  content="Save Changes"
                  onClick={() => {
                    formik.handleSubmit();
                    history.push(`/series`);
                  }}
                />
                <Button
                  as="a"
                  href={`${rebelmouseGowIdSiteMap[siteId]}/${current.full_url}`}
                  target="_blank"
                  content="Preview"
                  type="button"
                ></Button>
                <Button
                  type="button"
                  onClick={() => {
                    formik.handleSubmit();
                    setTimeout(() => {
                      window.open(`${rebelmouseGowIdSiteMap[siteId]}/${current.full_url}`, '_blank');
                    }, 3 * 1000);
                  }}
                  content="Save & Preview"
                ></Button>
                <Button
                  type="button"
                  onClick={() => {
                    formik.handleSubmit();
                    setTimeout(() => {
                      window.open(`${rebelmouseGowIdSiteMap[siteId]}/preview?series_id=${seriesId}`, '_blank');
                    }, 3 * 1000);
                  }}
                  content="Save & Preview Module"
                ></Button>
              </Form>
            </Segment>
          </>
        )}
      </Formik>
    </PageContainer>
  );

  return <>{current && getPage()}</>;
};

const mapStateToProps = state => ({
  users: selectors.photos.userOptions(state),
  user: selectors.getUser(state),
  query: selectors.content.query(state),
  newsItems: selectors.content.newsItems(state),
  count: selectors.content.count(state),
  sites: selectors.getCultureMapSites(state),
  currentSeries: selectors.series.current(state),
  seriesMap: selectors.series.seriesMap(state),
  dallasId: selectors.getDallasId(state),
  posts: selectors.series.posts(state),
  types: selectors.series.types(state),
});

const mapDispatchToProps = dispatch => ({
  getSeries: bindActionCreators(actions.series.getSeries, dispatch),
  getUsers: bindActionCreators(actions.photos.getUsers, dispatch),
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
  updateSeries: bindActionCreators(actions.series.updateSeries, dispatch),
  getSeriesPosts: bindActionCreators(actions.series.getSeriesPosts, dispatch),
  addPostToSeries: bindActionCreators(actions.series.addPostToSeries, dispatch),
  removePostFromSeries: bindActionCreators(actions.series.removePostFromSeries, dispatch),
  tagPost: bindActionCreators(actions.content.tagPost, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditSeriesPage);
